import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import FarmersmarketWeeklyVendors from "./FarmersMarketWeeklyVendors";
import FarmersmarketRotatingVendors from "./FarmersMarketRotatingVendors";
import FarmersmarketRawLocalHoney from "./FarmersMarketRawLocalHoney";

class FarmersMarket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      farmersmarketpage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "farmersmarket",
    }).then((entries) => {
      this.setState({ farmersmarketpage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(farmersmarketDescription) {
    return {
      __html: marked(farmersmarketDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <div className="container-fluid">
        {this.state.farmersmarketpage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.farmersmarketpage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.farmersmarketTitle}</h1>
                    <h2 className="lead">{item.fields.farmersmarketShortDetails}</h2>
                    <h2 className="lead">{item.fields.farmersmarketShortTwo}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.farmersmarketImg.fields.file.url}
                          alt="farmers market"
                        />
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.farmersmarketDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.farmersmarketDescription
                        )}></div>
                        <div><FarmersmarketWeeklyVendors/></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      <div><FarmersmarketRotatingVendors/></div>
      <div><FarmersmarketRawLocalHoney/></div>
     
      </div>
      
    );
  }
}

export default FarmersMarket;
